export const nestedPageNodeName = 'page';
export const nestedPageMarkdownEnclosure = 'MARKDOWN_NESTED_PAGE';
